import { filter } from 'lodash';
import { useEffect, useState } from 'react';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Backdrop,
  Fade,
  Box,
  Grid,
  useMediaQuery,
  useTheme,
  TextField,
  Fab,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  Autocomplete,
  TableHead,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Chip
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import DescriptionIcon from '@mui/icons-material/Description';

import { KeyboardArrowUp as KeyboardArrowUpIcon, Sort as SortIcon } from '@material-ui/icons';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../components/_dashboard/user';
import UserCard2 from '../components/UserCard2';
import DocumentReviewModal from '../components/_dashboard/user/DocumentReviewModal';
import { format, isBefore, subDays, isSameDay } from 'date-fns';
import userAPI from 'utils/api/users';
import storage from 'utils/storage';
import useRequiredDocuments from 'utils/api/requiredDocuments';
import Bugsnag from '@bugsnag/js';
import QRCode from "qrcode.react";
import QrReader from 'react-qr-reader'
import html2canvas from 'html2canvas';
import LoadingScreen from 'components/LoadingScreen'
const moment = require('moment-timezone')
moment().tz('Asia/Manila').format()
const current_date = `${moment().tz('Asia/Manila').toISOString(true)}`

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email address', alignRight: false },
  { id: 'company', label: 'Company', alignRight: false },
  { id: 'phone', label: 'Phone', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'documentStatus', label: 'Documents', alignRight: false },
  { id: 'qr', label: 'QR Code', alignRight: false },
  { id: 'login', label: 'Last login', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
  { id: '' },
];

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, documentFilters) {
  // Check if the array is valid and not empty
  if (!Array.isArray(array) || array.length === 0) {
    return []; // Return an empty array if input is invalid or empty
  }

  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);
  
  if (query) {
    filteredArray = filter(
      filteredArray,
      (_user) => (_user.displayName ? _user.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1 : '')
    );
  }

  // Apply document status filters if any are active
  if (documentFilters && Object.values(documentFilters).some(value => value)) {
    filteredArray = filteredArray.filter(user => {
      if (!user.documentStatus) return documentFilters.noDocuments;
      if (user.documentStatus === 'pending_approval') return documentFilters.pending;
      if (user.documentStatus === 'approved') return documentFilters.approved;
      if (user.documentStatus === 'rejected') return documentFilters.rejected;
      if (user.documentStatus === 'expired') return documentFilters.expired;
      if (user.documentStatus === 'missing') return documentFilters.noDocuments;
      return true;
    });
  }

  return filteredArray;
}

export default function User() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState();
  const [name, setName] = useState();
  const [action, setAction] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [company, setCompany] = useState([])
  const [user, setUser] = useState()
  const [openQR, setOpenQR] = useState(false)
  const [selectedCompany, setSelectedCompany] = useState('')
  const [count, setCount] = useState()
  const [isLoading, setLoading] = useState(false)
  const d = new Date();
  const [date, setDate] = useState(d.setDate(d.getDate() - 1))
  const [documentFilters, setDocumentFilters] = useState({
    pending: false,
    approved: false,
    rejected: false,
    expired: false,
    noDocuments: false
  });
  const [openDocumentFilter, setOpenDocumentFilter] = useState(false);
  const [filterMenuAnchorEl, setFilterMenuAnchorEl] = useState(null);
  const [openDocumentReview, setOpenDocumentReview] = useState(false);
  const [selectedUserIdForReview, setSelectedUserIdForReview] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === 'visible') {
  //       loadUserData();
  //     }
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);

  //   // Clean up
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);

  const loadUserData = async () => {
    setLoading(true);
    try {
      const local_user = await storage.getUser();
      if (!local_user) return;

      const user = JSON.parse(local_user);
      setUser(user);
      const formattedDate = moment(date).format('YYYY-MM-DD');

      if (user.role >= 3) {
        const getCompany = await userAPI.get_group_store(user._id);
        if (getCompany.status === 200) {
          setCompany(getCompany.data.report.store);
          if (getCompany.data.report.store.length > 0) {
            // Use selectedCompany if it exists and is in the store list, otherwise use first store
            const storeToUse = selectedCompany && getCompany.data.report.store.includes(selectedCompany) 
              ? selectedCompany 
              : getCompany.data.report.store[0];
            
            // Only update selectedCompany if it's not already set or if it's not in the current store list
            if (!selectedCompany || !getCompany.data.report.store.includes(selectedCompany)) {
              setSelectedCompany(storeToUse);
            }
            
            const data = {
              store: storeToUse,
            };
            const storeResult = await userAPI.get_user_bystore(data);
            
            // Get document status for each user
            const usersWithDocStatus = await fetchUsersDocumentStatus(storeResult.data);
            
            setUsers(usersWithDocStatus);
            setCount(storeResult.data.length - 1);
          } else {
            setUsers([]);
            setCount(0);
            setSelectedCompany();
          }
        }
      } else {
        const result = await userAPI.get_users(user._id);
        if (!result.ok) {
          Bugsnag.notify(result);
          return;
        } 
        
        // Get document status for each user
        const usersWithDocStatus = await fetchUsersDocumentStatus(result.data);
        
        setUsers(usersWithDocStatus);
      }
    } catch (error) {
      console.error("Error loading user data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUserData();
  }, []);

  // Fetch document status for all users using bulk API (optimized)
  const fetchUsersDocumentStatus = async (usersList) => {
    try {
      // If no users, return empty array
      if (!usersList || usersList.length === 0) {
        return [];
      }
      
      // Get user data to extract company information
      const local_user = await storage.getUser();
      if (!local_user) {
        console.error('No user data found');
        return usersList.map(user => ({ ...user, documentStatus: 'error' }));
      }
      
      const userData = JSON.parse(local_user);
      
      // Use selectedCompany for admin users, fallback to user's company
      let targetCompany = userData.company;
      if (userData.role >= 3 && selectedCompany) {
        targetCompany = selectedCompany;
      }
      
      if (!targetCompany) {
        console.error('No company data found');
        return usersList.map(user => ({ ...user, documentStatus: 'error' }));
      }
      
      // Extract employee IDs
      const employeeIds = usersList.map(user => user._id);
      
      // Make single bulk API call for all employees using the correct company context
      const bulkResponse = await useRequiredDocuments.get_bulk_employee_documents(employeeIds, targetCompany);
      
      if (bulkResponse.status !== 200 || !bulkResponse.data.success) {
        console.error('Bulk API call failed:', bulkResponse);
        return usersList.map(user => ({ ...user, documentStatus: 'error' }));
      }
      
      const { employeeDocumentStatus } = bulkResponse.data.data;
      
      // Map the bulk response data to users
      const updatedUsers = usersList.map(user => {
        const docStatus = employeeDocumentStatus[user._id];
        
        if (!docStatus) {
          return { ...user, documentStatus: 'unknown' };
        }
        
        return {
          ...user,
          documentStatus: docStatus.status,
          documentCounts: docStatus.counts
        };
      });
      
      return updatedUsers;
    } catch (error) {
      console.error('Error in fetchUsersDocumentStatus:', error);
      // Return users with error status if the whole function fails
      return usersList.map(user => ({ ...user, documentStatus: 'error' }));
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleClose = () => setOpen(false);

  const handleGenerateQR = (e) => {
    setOpen(true);
    setId(e.target.id);
    setName(e.target.value);
  };

  const handleAction = (id) => {
    // Handle action
  };

  const handleDeleteStore = async () => {
    setLoading(true);
    const data = {
      "store": selectedCompany,
      "id": user._id
    };
    await userAPI.delete_group_store(data);
    await loadUserData();
    setLoading(false);
  };

  const downloadQRCode = () => {
    const qrCodeElement = document.getElementById("qr-gen");
    html2canvas(qrCodeElement).then(canvas => {
      const pngUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `${name}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };

  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName, documentFilters);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const isUserNotFound = filteredUsers.length === 0;

  const handleSortMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSortMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDocumentFilterMenuOpen = (event) => {
    setFilterMenuAnchorEl(event.currentTarget);
    setOpenDocumentFilter(true);
  };

  const handleDocumentFilterMenuClose = () => {
    setFilterMenuAnchorEl(null);
    setOpenDocumentFilter(false);
  };

  const handleDocumentFilterChange = (filter) => {
    setDocumentFilters({
      ...documentFilters,
      [filter]: !documentFilters[filter]
    });
  };

  const handleResetDocumentFilters = () => {
    setDocumentFilters({
      pending: false,
      approved: false,
      rejected: false,
      expired: false,
      noDocuments: false
    });
  };

  const getDocumentStatusLabel = (status, counts) => {
    if (!status || status === 'unknown' || status === 'error') {
      return (
        <Tooltip title="Unknown document status">
          <Chip 
            icon={<DescriptionIcon />} 
            label="Unknown" 
            color="default" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'missing') {
      return (
        <Tooltip title={`Missing required documents (${counts?.missing || '?'})`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Missing (${counts?.missing || '?'})`} 
            color="default" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'pending_approval') {
      return (
        <Tooltip title={`${counts?.pending || '?'} document(s) pending review`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Pending (${counts?.pending || '?'})`} 
            color="warning" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'rejected') {
      return (
        <Tooltip title={`${counts?.rejected || '?'} document(s) rejected`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Rejected (${counts?.rejected || '?'})`} 
            color="error" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'expired') {
      return (
        <Tooltip title={`${counts?.expired || '?'} document(s) expired`}>
          <Chip 
            icon={<DescriptionIcon />} 
            label={`Expired (${counts?.expired || '?'})`} 
            color="error" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    if (status === 'approved') {
      return (
        <Tooltip title="All documents approved">
          <Chip 
            icon={<DescriptionIcon />} 
            label="Approved" 
            color="success" 
            size="small" 
          />
        </Tooltip>
      );
    }
    
    return null;
  };

  const handleSortChange = (property) => {
    handleRequestSort(null, property);
    handleSortMenuClose();
  };

  const handleStoreChange = async (value) => {
    if (value === selectedCompany || value === null) return;
    
    setLoading(true);
    try {
      setSelectedCompany(value);
      
      // Fetch users for the selected store
      const data = {
        store: value,
      };
      const storeResult = await userAPI.get_user_bystore(data);
      
      // Get document status for each user with the new company context
      const usersWithDocStatus = await fetchUsersDocumentStatus(storeResult.data);
      
      setUsers(usersWithDocStatus);
      setCount(storeResult.data.length - 1);
    } catch (error) {
      console.error("Error changing store:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenQRModal = async () => {
    setOpenQR(true)
  }

  const handleCloseQR = () => {
    setOpenQR(false)
  }

  const handleError = (err) => {
    alert(err)
  }

  const handleScan = async (res) => {
    const url = new URL(res);
    const pathSegments = url.pathname.split("/");
    const id = pathSegments[1];
    const data = {
      "uid": user._id,
      "storeid": id
    }
    if (res) {
      const result = await userAPI.post_group_store(data)
      if (result.status === 200) {
        // load()
        setOpenQR(false)
        alert("Success")
      }
      else {
        alert("Something went wrong please try again later!")
      }
    } else {
      alert("No link found in the response.");
    }
  };

  // Count active document filters
  const activeDocumentFilterCount = Object.values(documentFilters).filter(Boolean).length;

  // Add a refreshDocumentStatus function for specific users
  const refreshDocumentStatus = async (userId) => {
    // Find the user in the current list
    const userToUpdate = users.find(u => u._id === userId);
    if (!userToUpdate) return;
    
    try {
      // Get updated document status for just this user with correct company context
      const [updatedUser] = await fetchUsersDocumentStatus([userToUpdate]);
      
      // Update this specific user in the list
      setUsers(prevUsers => 
        prevUsers.map(user => 
          user._id === userId ? updatedUser : user
        )
      );
    } catch (error) {
      console.error("Error refreshing document status:", error);
    }
  };
  
  // Enhanced document status refresh for all users
  const refreshAllDocumentStatus = async () => {
    if (!users || users.length === 0) return;
    
    setLoading(true);
    try {
      const usersWithDocStatus = await fetchUsersDocumentStatus(users);
      setUsers(usersWithDocStatus);
    } catch (error) {
      console.error("Error refreshing all document status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDocumentReview = (userId) => {
    setSelectedUserIdForReview(userId);
    setOpenDocumentReview(true);
  };

  const handleCloseDocumentReview = () => {
    setOpenDocumentReview(false);
    setSelectedUserIdForReview(null);
    loadUserData();
  };

  return (
    <Page title="User | Time In">
      {isLoading ? (
        <Box sx={{ height: '50vh' }}>
          <LoadingScreen />
        </Box>
      ) : (
        <>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom>
              User
            </Typography>
          </Stack>


          {isMobile ? (
            <>
              <Grid container spacing={2}>
                {user && user.role >= 3 && (
                  <Grid item xs={12} md={4}>
                    <Box display="flex" justifyContent="center">
                      <FormControl sx={{ ml: 3, width: "85%" }}>
                        <Box display="flex" alignItems="center">
                        <Autocomplete
                            id="store-select"
                            value={selectedCompany === null ? company[0] : selectedCompany}
                            onChange={(event, value) => handleStoreChange(value)}
                            options={company}
                            placeholder='Store'
                            renderInput={(params) => (
                              <TextField {...params} label="Store" />
                            )}
                            sx={{
                              flexGrow: 1,
                              whiteSpace: 'nowrap',
                              overflow: 'auto',
                              textOverflow: 'ellipsis',
                              pt: 1
                            }}
                          />
                          <IconButton color="primary" aria-label="add store" onClick={handleOpenQRModal} sx={{ ml: 0 }}>
                            <AddIcon />
                          </IconButton>
                          <IconButton color="primary" aria-label="delete store" onClick={handleDeleteStore} sx={{ ml: 0 }}>
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </FormControl>
                    </Box>
                  </Grid>
                )}
                
                <Grid item xs={12} md={4}>
                  <Box display="flex" justifyContent="center">
                    <TextField
                      fullWidth
                      label="Search User"
                      value={filterName}
                      onChange={handleFilterByName}
                      sx={{ maxWidth: '80%' }} 
                    />
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={4}>
                  <Box display="flex" justifyContent="center">
                    <Tooltip title="Filter by document status">
                      <IconButton 
                        onClick={handleDocumentFilterMenuOpen}
                        color={activeDocumentFilterCount > 0 ? "primary" : "default"}
                        sx={{ position: 'relative' }}
                      >
                        <FilterListIcon />
                        {activeDocumentFilterCount > 0 && (
                          <Box
                            component="span"
                            sx={{
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              width: 16,
                              height: 16,
                              borderRadius: '50%',
                              backgroundColor: 'primary.main',
                              color: 'white',
                              fontSize: '0.75rem',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            {activeDocumentFilterCount}
                          </Box>
                        )}
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="subtitle2">
                  {filteredUsers.length} items
                </Typography>
                <IconButton onClick={handleSortMenuOpen}>
                  <SortIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleSortMenuClose}
                >
                  {TABLE_HEAD.map((headCell) => (
                    <MenuItem key={headCell.id} onClick={() => handleSortChange(headCell.id)}>
                      Sort by {headCell.label}
                    </MenuItem>
                  ))}
                </Menu>
              </Stack>
              {filteredUsers.map((user) => (
                <UserCard2 
                  key={user._id} 
                  user={user} 
                  handleGenerateQR={handleGenerateQR} 
                  handleAction={handleAction}
                  documentStatus={user.documentStatus}
                  documentCounts={user.documentCounts}
                  onNameClick={() => handleOpenDocumentReview(user._id)}
                />
              ))}
            </>
          ) : (
            <Card sx={{ width: '100%' }}>
              <Grid container spacing={2}>
                {user && user.role >= 3 && (
                  <Grid item sx={{ flexGrow: 1 }}>
                    <FormControl sx={{ mt: 2, ml: 3, width: "85%" }}>
                      <Box display="flex" alignItems="center">
                          <Autocomplete
                            id="store-select"
                            value={selectedCompany === null ? company[0] : selectedCompany}
                            onChange={(event, value) => handleStoreChange(value)}
                            options={company}
                            placeholder='Store'
                            renderInput={(params) => (
                              <TextField {...params} label="Store" />
                            )}
                            sx={{
                              width: '100%',
                              whiteSpace: 'nowrap',
                              overflow: 'auto',
                              textOverflow: 'ellipsis',
                              pt: 1
                            }}
                          />
                        <IconButton color="primary" aria-label="add store" onClick={handleOpenQRModal} sx={{ ml: 1 }}>
                          <AddIcon />
                        </IconButton>
                        <IconButton color="primary" aria-label="delete store" onClick={handleDeleteStore} sx={{ ml: 0 }}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </FormControl> 
                  </Grid>
                )}
                <Grid item sx={{ flexGrow: 1 }}>
                  <Box display="flex" alignItems="center">
                    <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
                    <Tooltip title="Filter by document status">
                      <IconButton 
                        onClick={handleDocumentFilterMenuOpen}
                        color={activeDocumentFilterCount > 0 ? "primary" : "default"}
                        sx={{ position: 'relative', mr: 1 }}
                      >
                        <FilterListIcon />
                        {activeDocumentFilterCount > 0 && (
                          <Box
                            component="span"
                            sx={{
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              width: 16,
                              height: 16,
                              borderRadius: '50%',
                              backgroundColor: 'primary.main',
                              color: 'white',
                              fontSize: '0.75rem',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            {activeDocumentFilterCount}
                          </Box>
                        )}
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Refresh document status">
                      <IconButton 
                        onClick={refreshAllDocumentStatus}
                        disabled={isLoading}
                        sx={{ mr: 2 }}
                      >
                        <DescriptionIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
              <Scrollbar>
                <TableContainer sx={{ width: '100%' }}>
                  {users ? (
                    <Table>
                      <TableHead>
                        <UserListHead
                          order={order}
                          orderBy={orderBy}
                          headLabel={TABLE_HEAD}
                          rowCount={users ? users.length : 0}
                          numSelected={selected.length}
                          onRequestSort={handleRequestSort}
                          onSelectAllClick={handleSelectAllClick}
                        />
                      </TableHead>
                      <TableBody sx={{ width: '3000px' }}>
                        {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                          const {
                            _id,
                            firstName,
                            displayName,
                            lastName,
                            email,
                            phone,
                            role,
                            isOnBoarded,
                            company,
                            image,
                            isVerified,
                            updatedAt,
                            documentStatus,
                            documentCounts
                          } = row;
                          const updatedDate = new Date(updatedAt);
                          const fifteenDaysAgo = subDays(new Date(), 15);
                          const fourDaysAgo = subDays(new Date(), 4);
                          const isOld = isBefore(updatedDate, fifteenDaysAgo);
                          const isFourDaysOld = isSameDay(updatedDate, fourDaysAgo)
                          // let name = `${firstName} ${lastName}`;
                          let name = `${displayName}`
                          if (firstName === null || lastName === null) {
                            name = displayName;
                          }
                          const isItemSelected = selected.indexOf(name) !== -1;
                          return (
                            <TableRow
                              hover
                              key={_id}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell component="th" scope="row" padding="none">
                                <Stack direction="row" alignItems="center" spacing={2}>
                                  <Avatar sx={{ ml: 2 }} alt={name} src={image} className="ml-3" />
                                  <Typography 
                                    variant="subtitle2" 
                                    noWrap
                                    onClick={() => handleOpenDocumentReview(_id)}
                                    sx={{ 
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        color: 'primary.main'
                                      }
                                    }}
                                  >
                                    {name}
                                  </Typography>
                                </Stack>
                              </TableCell>
                              <TableCell align="left">{email}</TableCell>
                              <TableCell align="left">{company}</TableCell>
                              <TableCell align="left">{phone}</TableCell>
                              <TableCell align="left">
                                <Label variant="ghost" color={'info'}>
                                  {role === 1 ? 'Store' : 'Employee'}
                                </Label>
                              </TableCell>
                              <TableCell align="left">{isVerified ? 'Yes' : 'No'}</TableCell>
                              <TableCell align="left">
                                <Label variant="ghost" color={!isOnBoarded ? 'error' : 'success'}>
                                  {isOnBoarded ? 'Complete' : 'Incomplete'}
                                </Label>
                              </TableCell>
                              <TableCell align="left">
                                {getDocumentStatusLabel(documentStatus, documentCounts)}
                              </TableCell>
                              <TableCell align="left">
                                <Button size="small" id={_id} value={name} onClick={(e) => handleGenerateQR(e)}>Generate QR</Button>
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{
                                  color: isOld ? 'red' : isFourDaysOld ? 'orange' : 'inherit',
                                }}
                              >
                                {new Date(updatedAt).toLocaleDateString()}
                              </TableCell>
                              <TableCell align="right">
                                <UserMoreMenu 
                                  id={_id} 
                                  action={setAction} 
                                  onDocumentUpdate={() => refreshDocumentStatus(_id)} 
                                  onOpenDocumentReview={() => handleOpenDocumentReview(_id)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                      {isUserNotFound && (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                              <SearchNotFound searchQuery={filterName} />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </Table>
                  ) : (
                    ''
                  )}
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={users ? users.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={"Rows per page"}
              />
            </Card>
          )}

          {/* Document Filter Menu */}
          <Menu
            anchorEl={filterMenuAnchorEl}
            open={openDocumentFilter}
            onClose={handleDocumentFilterMenuClose}
          >
            <MenuItem>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Document Status Filters
              </Typography>
            </MenuItem>
            <MenuItem>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={documentFilters.pending}
                      onChange={() => handleDocumentFilterChange('pending')}
                      name="pending"
                      color="warning"
                    />
                  }
                  label="Pending Review"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={documentFilters.approved}
                      onChange={() => handleDocumentFilterChange('approved')}
                      name="approved"
                      color="success"
                    />
                  }
                  label="Approved"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={documentFilters.rejected}
                      onChange={() => handleDocumentFilterChange('rejected')}
                      name="rejected"
                      color="error"
                    />
                  }
                  label="Rejected"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={documentFilters.expired}
                      onChange={() => handleDocumentFilterChange('expired')}
                      name="expired"
                      color="error"
                    />
                  }
                  label="Expired"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={documentFilters.noDocuments}
                      onChange={() => handleDocumentFilterChange('noDocuments')}
                      name="noDocuments"
                    />
                  }
                  label="Missing Documents"
                />
              </FormGroup>
            </MenuItem>
            <MenuItem>
              <Button 
                variant="outlined" 
                fullWidth 
                onClick={handleResetDocumentFilters}
                disabled={!Object.values(documentFilters).some(Boolean)}
              >
                Reset Filters
              </Button>
            </MenuItem>
          </Menu>

          <Fab
            color="primary"
            aria-label="scroll back to top"
            sx={{
              position: 'fixed',
              bottom: 26,
              left: '50%',
              transform: 'translateX(-50%)',
              opacity: 0.8
            }}
            onClick={() => window.scrollTo(0, 0)}
          >
            <KeyboardArrowUpIcon />
          </Fab>

          <Modal
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                <div id="qr-gen">
                  <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
                    {`${name}`}
                  </Typography>
                  <Grid container sx={{ pl: 2 }}>
                    <QRCode
                      size={300}
                      value={id}
                    />
                  </Grid>
                </div>

                <Button variant="contained" color="success" onClick={downloadQRCode} sx={{ mt: 2, px: 17 }}>
                  {`Print QR for ${name}`}
                </Button>
              </Box>
            </Fade>
          </Modal>

          <Dialog open={openQR} onClose={handleCloseQR}>
            <DialogTitle>Scan store QR code.
              <IconButton
                aria-label="close"
                onClick={handleCloseQR}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle >
            <DialogContent>
              <>
                <QrReader
                  delay={3000}
                  onError={handleError}
                  onScan={handleScan}
                  // chooseDeviceId={()=>selected}
                  style={{ width: '250px', heigth: '200px' }}
                // className={'qrScanner'}
                />
                {/*<DialogTitle style={{ display: "flex", justifyContent: "center" }}><a href="https://www.sparkletimekeeping.com/store/create">Register store account</a></DialogTitle>*/}
              </>
            </DialogContent>
          </Dialog>

          {/* Document Review Modal */}
          {selectedUserIdForReview && (
            <DocumentReviewModal
              open={openDocumentReview}
              onClose={handleCloseDocumentReview}
              employeeId={selectedUserIdForReview}
              company={user && user.role >= 3 ? selectedCompany : (user && user.company)}
            />
          )}
        </>
      )}


    </Page>
  );
}